import React, { useContext,useState,useEffect,useRef } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import StoryCard from "./StoryCard";
import '../../styles/global.css'
import { globalContext } from "../../App";
import LatestList from "./latestList";
import LatestNews from "./latestNews";
import SkeletonStoryCard from "./skeletonStoryCard";

let hasHydratedOnce = false;

function SkeletonSection() {
  return (
   
      <div className="stories-grid">
        {[0,0,0].map((s, index) => (
          <SkeletonStoryCard key={index}  />
        ))}
      </div>
    
  );
}


export default function Category({data}) {


            const ssrData = data?.[0]?.category || {}
            const ssrCategoryData = ssrData?.categoryData
            const ssrCatId = ssrData.ssrCatId
            const { category } = useParams();
            const {cats,setCats} = useContext(globalContext)
            const catMeta = cats.find((c) => c.to === category);
            const label = catMeta ? catMeta.label : category;
            const [items,setItems] = useState(ssrCategoryData)
            const limit = 9
            const startRef = useRef(items ? limit : 0);
            const  [hasMore,setHasMore]=useState(true)
            const [loading,setLoading]=useState(false);
            const [error,setError]=useState(null);
            const location=useLocation().pathname
           
            let catIdRef = useRef(ssrCatId)
            let isFirst = useRef(true)

          

   const callData = async () => {
           
         
    
         let cat_id=catMeta.id


     
            try {
                 
                 
            const response = await fetch(`https://www.teluguone.com/news_api/newsSelectedCatWebStoresJson?feature_id=${cat_id}&limit=${limit}&start=${startRef.current}`);
              
                if (!response.ok) throw new Error('Network response was not ok');
      
              const data = await response.json();
            
          
              let processedData=[]

              if (data.category_web_stories?.length < 2) {
                 setHasMore(false);
               } else {

                  processedData = data.category_web_stories
                
               }

 
      
               
           
                
              setItems((prevItems) => [...prevItems, ...processedData]);
              startRef.current += limit; 
              setLoading(false)
              setError(null)
      
            } catch (error) {
                 setItems([])
                 startRef.current = 0;
                 setLoading(false)
                 setError(error.message)   
                 console.error('Error fetching slider data:', error);
            }

           
          
        
           

          }; 
     
     
        useEffect(() => {
     
        
     
          let cat_id=catMeta?.id
         
          if(!catMeta) return; 
  
            if (ssrCategoryData && hasHydratedOnce) {
              catIdRef.current = cat_id;
               hasHydratedOnce = true;
              setLoading(false);
              setError(null);
              return;
            }

           


            setItems([]);
            startRef.current = 0;
            setHasMore(true);
            setLoading(true);
            setError(null);
            catIdRef.current = cat_id;

            const fetchData = async () => {
             
              try {
                const response = await fetch(
                  `https://www.teluguone.com/news_api/newsSelectedCatWebStoresJson?feature_id=${cat_id}&limit=${limit}&start=${startRef.current}`
                );

                if (!response.ok) throw new Error("Network response was not ok");

                const data = await response.json();
                const items = data?.category_web_stories || [];
                if (items.length === 0) {
                  setHasMore(false);
                } else {
                  const processed = items

                  setItems(processed);
                  startRef.current += limit;
                }

                setError(null);

              } catch (err) {
                setItems([]);
                setHasMore(false);
                setError(err.message);
              } finally {
                setLoading(false);
                isFirst.current = false;
              }
            };


       
            fetchData();

        }, [location, limit,catMeta]);


  


           

  return (
    <div className="main-container">
     
      <div className="layer-breadcrumb">
        <Link to="/">Home</Link>
        <span>»</span>
        {label}
      </div>

      <div className="home-layout">
        <aside className="home-sidebar shadow-lg">
            <h3>Latest news</h3>
            <LatestNews />
        </aside>

        <div>
          <div className="section-title">
            <h2>{label}</h2>
          </div>
          {loading ?  <SkeletonSection /> : error ? <div className="stories-grid">No Data</div>
          : items && items.length === 0 ? (
            <p style={{ padding: 20 }}>No Stories.</p>
          ) : (
            <div className="stories-grid">
              {items && items.map((s,index) => (
                <StoryCard key={index} story={s} />
              ))}
            </div>
          )}
          {hasMore && items ? <ItemsViewMore fetchData={callData}   /> : <p className='text-center mt-5 mb-5'>No More Data Found</p>}
        </div>


       <aside className="home-sidebar shadow-lg">
             <div className="sidebar-widget">
          <div className="widget-header">
            <h3>Latest Pics</h3>
          </div>
          <LatestList />
        </div>
         </aside>
      </div>


    </div>
  );
}




const ItemsViewMore = ({fetchData,  cat_id}) => {
  
              const [link,setLink]=useState('')
            
              useEffect(() => {

                if (cat_id !== null || cat_id !== undefined) {
              
                  switch (cat_id) {
                    case '7':
                  setLink('/contents/vegetarian-7.html')
                    break;
                
                    case '6':
                    setLink('/contents/non-vegetarian-6.html')
                    break;
                
                    case '8':
                    setLink('/contents/sweetsndeserts-8.html')
                    break;
                
                    case '4':
                    setLink('/contents/rice-4.html')
                      break;
                
                    case '9':
                    
                    setLink('/contents/pickles-9.html')
                      break;
                
                    case '1':
                    setLink('/contents/appetizers-1.html')
                      break;
                
                    case '2':
                    setLink('/contents/beverages-2.html')
                      break;
                    
                    case '13':
                    setLink('/contents/milletfood-13.html')
                      break;

                    default:
                    break;
              


                    }

                  }

              },[cat_id])
    
  
              return (
                <div className='col-12 d-flex mt-5 mb-5 justify-content-center align-items-center' >
                    <button type='button' onClick={() => fetchData()} className='btn btn-danger view-more-btn' > {cat_id ? <Link to={link} target='_blank' rel='no-referrer' >View More</Link> : 'View More'}</button>
                </div>
              )
}


